"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimRight = exports.trimLeft = void 0;
/**
 * Loại bỏ các kí tự `char` bên trái chuỗi `str`.
 * @param str Chuỗi bất kì.
 * @param char Kí tự cần loại bỏ.
 * @returns Chuỗi đã thực hiện loại bỏ.
 */
function trimLeft(str, char) {
    if (str === '')
        return '';
    let pos = 0;
    while (str[pos] === char[0])
        pos++;
    return str.substring(pos);
}
exports.trimLeft = trimLeft;
/**
 * Loại bỏ các kí tự `char` bên phải chuỗi `str`.
 * @param str Chuỗi bất kì.
 * @param char Kí tự cần loại bỏ.
 * @returns Chuỗi đã thực hiện loại bỏ.
 */
function trimRight(str, char) {
    if (str === '')
        return '';
    let lastPos = str.length - 1;
    while (str[lastPos] === char[0])
        lastPos--;
    return str.substring(0, lastPos + 1);
}
exports.trimRight = trimRight;
//# sourceMappingURL=Utils.js.map